import { createContext } from "react";

export type CharterTeamDisplayInfo = {
    id: string
    userName: string
    forename: string
    surname: string
}

export type majorMilestone = {
    workPackageId: number
    workPackageName: string
    tasks: {
        id: number
        name: string
        finishDate: Date
    }[]
}

export type Charter = {
    projectId: number
    projectName: string
    objective: string
    inScope: string
    outOfScope: string
    criticalSuccessFactors: string
    submittedForApproval: boolean
    submissionDate: Date | null
    submissionSeen: boolean
    sponsorApproval: boolean
    sponsorApprovalDate: Date | null
    sponsorId: string | null,
    sponsorName: string,
    sponsors: CharterTeamDisplayInfo[]
    projectManagers: CharterTeamDisplayInfo[]
    teamMembers: CharterTeamDisplayInfo[]
    majorMilestones: majorMilestone[]
}

interface CharterContextProps {
    charterData: Charter | undefined;
    setCharterData: (data: Charter) => void;
    refreshCharterData: () => void;
    charterLocked: boolean;
    setCharterLocked: (locked: boolean) => void;
    submitCharterForApproval?: () => void;
}

export const CharterContext = createContext<CharterContextProps>({
    charterData: undefined,
    setCharterData: () => {},
    refreshCharterData: () => {},
    charterLocked: false,
    setCharterLocked: () => {},
    submitCharterForApproval: () => {},
});